module.exports = __webpack_public_path__ + "static/media/zocaloPvcJ4.1ec32c44.jpg";